module.exports = __webpack_public_path__ + "static/media/icono.9dd6a393.png";